/**
 * Connectivity / power status pill — top-of-card label.
 *
 * This component shows the *connectivity* state, NOT operational state
 * like priming. Operational states (Priming, etc.) live in their own
 * row with the PrimingIcon — keeps the two axes independent and avoids
 * showing "Priming" twice on the same card.
 *
 * Color logic:
 *   not connected   → red    "Offline"
 *   connected + ON  → green  "Online"
 *   connected + OFF → grey   "Idle"
 */
export function StatusDot({
  connected,
  on,
  size = 10,
}: {
  connected: boolean;
  on: boolean;
  size?: number;
}) {
  let color: string;
  let label: string;

  if (!connected) {
    color = 'var(--aqua-offline)';
    label = 'Offline';
  } else if (on) {
    color = 'var(--aqua-online)';
    label = 'Online';
  } else {
    color = '#9aa0a6';
    label = 'Idle';
  }

  return (
    <span
      className="d-inline-flex align-items-center gap-1 small"
      title={label}
      aria-label={label}
    >
      <span
        style={{
          display: 'inline-block',
          width: size,
          height: size,
          borderRadius: '50%',
          backgroundColor: color,
          boxShadow: connected && on ? `0 0 0 3px ${color}25` : undefined,
        }}
      />
      <span className="text-muted">{label}</span>
    </span>
  );
}
